<template>
  <!-- Page Content Wrapper -->
  <div
    v-if="permissionsArray.includes('can_manage_users')"
    id="page-content-wrapper"
    class="admin-content-area"
  >
    <div class="container-fluid xyz">
      <div class="page-header-top-container">
        <div class="page-name">Load Data</div>
        <!--<button
          type="submit"
          v-on:click.prevent="backToCustomerList()"
          class="btn btn-primary waves-effect pull-right"
        >Back</button>-->
      </div>

      <!--Loading-->
      <!--<div class="loading-container">
                  <div class="loading">
                      <img src="/static/images/loading.gif">
                  </div>
      </div>-->
      <!--Loading-->

      <!--page content-->
      <div class="admin-page-content">
        <div class="forms-container add_user_forms_container">
          <div class="row no-margin">
            <!--Role-->
            <div class="col-6 forms-block">
              <div class="col-3 paddingleft0">
                <div class="form-label">Deal No :</div>
              </div>
              <div class="col-9 paddingleft0">
                <input class="form-control" id="name" placeholder="Deal No" v-model="deal_no" />
                <div class="requiredstar">*</div>
                <span class="text-danger">{{dealNoError}}</span>
              </div>
            </div>
            <!--Dayforce ID-->
            <div class="col-6 forms-block">
              <div class="col-3 paddingleft0">
                <input
                  :disabled="disableShow"
                  type="button"
                  value="Show"
                  class="btn btn-primary"
                  v-on:click.prevent="loadInventoryParts"
                />
              </div>
              <div class="col-3 paddingleft0">
                <input
                  :disabled="disableExport"
                  type="button"
                  value="Export Data"
                  class="btn btn-primary"
                  v-on:click.prevent="exportData"
                />
              </div>
              <div class="col-6 paddingleft0"></div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <template v-if="errorsArraySize > 0">
          <div class="forms-container add_user_forms_container" v-html="errorString">

          </div>
        </template>
        <div class="clearfix"></div>
        <div class="app-filter-good-table-container">
          <vue-good-table
            ref="listInventory"
            title="Inventory"
            :totalRows="totalRecords"
            :columns="columns"
            :rows="rows"
          ></vue-good-table>
        </div>
      </div>
      <!--page content-->
    </div>
    <app-footer></app-footer>
  </div>
  <div v-else>
    <no-permission></no-permission>
  </div>
  <!-- Page Content Wrapper -->
</template>

<script>
var self;
import Vue from "vue";
import Footer from "@/components/partials/Footer";
import EventBus from "@/components/event-bus";
import { commonMixins } from "../mixins/commonMixins";
import { HTTP } from "../http-common.js";
import VueGoodTable from "vue-good-table";
import NoAccessPermission from "@/components/NoAccessPermission";
import vSelect from "vue-select";

Vue.use(VueGoodTable);
export default {
  name: "listInventory",
  components: {
    "app-footer": Footer,
    "no-permission": NoAccessPermission,
    "v-select": vSelect
  },
  mixins: [commonMixins],
  data() {
    return {
      disableShow: false,
      disableExport: false,
      roleId: 0,
      firstLoad: 0,
      columns: [
        {
          label: "Deal no",
          field: "dealno",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Deal no", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Control Number",
          field: "Control_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Control Number", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEAL DATE ON CONTRACTS",
          field: "Deal_Date_on_Contract.date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEAL DATE ON CONTRACTS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ID NUMBER OF CAR SOLD (VIN)",
          field: "VIN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ID NUMBER OF CAR SOLD (VIN)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "AMOUNT FINANCED",
          field: "Amount_Financed",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "AMOUNT FINANCED", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "APPLICATION DATE",
          field: "Application_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "APPLICATION DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "APPLIED EQUITY FROM TRADE (LEASES)",
          field: "Application_Equity_from_Trade",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "APPLIED EQUITY FROM TRADE (LEASES)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "APPLICATION FEE FOR TITLE",
          field: "Application_Fee_for_Title",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "APPLICATION FEE FOR TITLE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ANNUAL PERCENTAGE RATE",
          field: "Annual_Percentage_Rate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ANNUAL PERCENTAGE RATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ADD/REM #1 DESCRIPTION",
          field: "Add_or_Rem_1_Description",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ADD/REM #1 DESCRIPTION", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ADD/REM #2 DESCRIPTION",
          field: "Add_or_Rem_2_Description",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ADD/REM #2 DESCRIPTION", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ADD/REM #3 DESCRIPTION",
          field: "Add_or_Rem_3_Description",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ADD/REM #3 DESCRIPTION", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ADD/REM #4 DESCRIPTION",
          field: "Add_or_Rem_4_Description",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ADD/REM #4 DESCRIPTION", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "VEHICLE SOLD AS IS Y/N",
          field: "Vehicle_Sold_As_Is",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "VEHICLE SOLD AS IS Y/N", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ASSIGNMENT FEE",
          field: "Assignment_Fee",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ASSIGNMENT FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "AUTOMATIC TRANSMISSION Y/N",
          field: "Automatic_Transmission",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "AUTOMATIC TRANSMISSION Y/N", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER ADDRESS",
          field: "Buyer_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER AGE",
          field: "Buyer_Age",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER AGE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER BIRTH DATE",
          field: "Buyer_Birth_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER BIRTH DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER BIRTH STATE",
          field: "Buyer_Birth_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER BIRTH STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER BIRTH MONTH",
          field: "Buyer_Birth_Month",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER BIRTH MONTH", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER CITY",
          field: "Buyer_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        }, //////
        {
          label: "BUYER COUNTY",
          field: "Buyer_County",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER COUNTY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER DRIVERS LICENSE NUMBER",
          field: "Buyer_Drivers_License_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER DRIVERS LICENSE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER FIRST NAME & MIDDLE INITIAL",
          field: "Buyer_First_Name_and_Middle_Initial",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER FIRST NAME & MIDDLE INITIAL", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER HOME PHONE",
          field: "Buyer_Phone",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER HOME PHONE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER LAST NAME",
          field: "Buyer_Last_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER LAST NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYERS FULL MIDDLE NAME",
          field: "Buyer_Middle_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYERS FULL MIDDLE NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER FULL NAME (THRU SOFTWARE)",
          field: "Buyer_Full_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER FULL NAME (THRU SOFTWARE)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYERS SEX",
          field: "Buyer_Sex",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYERS SEX", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER SOCIAL SECURITY NUMBER",
          field: "Buyer_SSAN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER SOCIAL SECURITY NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER STATE",
          field: "Buyer_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER NAME SUFFIX",
          field: "Buyer_Name_Suffix",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER NAME SUFFIX", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER WORK PHONE",
          field: "Buyer_Work_Phone",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER WORK PHONE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER ZIP",
          field: "Buyer_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER ZIP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK ADDRESS",
          field: "Bank_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK CITY",
          field: "Bank_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK COUNTY",
          field: "Bank_County",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK COUNTY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK NAME",
          field: "Bank_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK PHONE NUMBER",
          field: "Bank_Phone_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK PHONE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK STATE",
          field: "Bank_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK ZIP",
          field: "Bank_Zip",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK ZIP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BENEFICIARY NAME",
          field: "Beneficiary_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BENEFICIARY NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BENEFICIARY ADDRESS",
          field: "Beneficiary_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BENEFICIARY ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BENEFICIARY CITY STATE & ZIP",
          field: "Beneficiary_City_State_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BENEFICIARY CITY STATE & ZIP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER ADDRESS",
          field: "Co-Buyer_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER AGE",
          field: "Co-Buyer_Age",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER AGE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER BIRTH DATE",
          field: "Co-Buyer_Birth_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER BIRTH DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER BIRTH STATE",
          field: "Co-Buyer_Birth_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER BIRTH STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER BIRTH MONTH",
          field: "Co-Buyer_Birth_Month",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER BIRTH MONTH", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER CITY",
          field: "Co-Buyer_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER COUNTY",
          field: "Co-Buyer_County",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER COUNTY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER DRIVERS LICENSE NUMBER",
          field: "Co-Buyer_Drivers_License_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER DRIVERS LICENSE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER FIRST NAME & MIDDLE INITIAL",
          field: "Co-Buyer_First_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER FIRST NAME & MIDDLE INITIAL", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER HOME PHONE",
          field: "Co-Buyer_Home_Phone",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER HOME PHONE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER LAST NAME",
          field: "Co-Buyer_Last_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER LAST NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYERS FULL MIDDLE NAME",
          field: "Co-Buyer_Full_Middle_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYERS FULL MIDDLE NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER FULL NAME (THRU SOFTWARE)",
          field: "Co-Buyer_Full_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER FULL NAME (THRU SOFTWARE)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYERS SEX",
          field: "Co-Buyer_Sex",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYERS SEX", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER SOCIAL SECURITY NUMBER",
          field: "Co-Buyer_SSAN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER SOCIAL SECURITY NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER STATE",
          field: "Co-Buyer_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER WORK PHONE",
          field: "Co-Buyer_Work_Phone",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER WORK PHONE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "NUMERIC YEAR FROM DEAL DATE",
          field: "Numeric_Year_from_Deal_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "NUMERIC YEAR FROM DEAL DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-BUYER ZIP",
          field: "Co-Buyer_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-BUYER ZIP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CARLINE OF VEHICLE SOLD",
          field: "Carline_of_Vehicle_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CARLINE OF VEHICLE SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CITY TAX AMOUNT",
          field: "Tax_Amount",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CITY TAX AMOUNT", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COLOR OF CAR SOLD",
          field: "Color_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COLOR OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COLOR CODE OF CAR SOLD",
          field: "Color_Code_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COLOR CODE OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COUNTY TAX RATE",
          field: "County_Tax_Rate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COUNTY TAX RATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COMMERCIAL Y/N",
          field: "Commercial",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COMMERCIAL Y/N", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COMPANY NAME OF DEALER",
          field: "Company_Name_of_Dealer",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COMPANY NAME OF DEALER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER COMPANY",
          field: "Buyers_Company",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER COMPANY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CONJUNCTION IN SYSTEM CONTROL FILE",
          field: "Conjuction_in_System_Control_File",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CONJUNCTION IN SYSTEM CONTROL FILE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "IS CO-BUYER CO-OWNER Y/N",
          field: "Is_Co-Buyer_Co-Owner",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "IS CO-BUYER CO-OWNER Y/N", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER OR GUARANTOR IN CONTRACT",
          field: "Cosigner_or_Guarantor_in_Contract",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER OR GUARANTOR IN CONTRACT", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CO-SIGNER ON CONTRACT Y/N",
          field: "Co-Signer_on_Contract",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CO-SIGNER ON CONTRACT Y/N", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COST OF VEHICLE",
          field: "Cost_of_Vehicle",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COST OF VEHICLE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COUNTY NUMBER",
          field: "County_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COUNTY NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COUNTY TAX AMOUNT",
          field: "County_Tax_Amount",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COUNTY TAX AMOUNT", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNR ADDRESS",
          field: "Cosigner_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNR ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER AGE",
          field: "Cosigner_Age",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER AGE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER BIRTH DATE",
          field: "Cosigner_Birth_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER BIRTH DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER CITY",
          field: "Cosigner_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER COUNTY",
          field: "Cosigner_County",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER COUNTY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER DRIVERS LICENSE NUMBER",
          field: "Cosigner_Drivers_License_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER DRIVERS LICENSE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNERS FIRST NAME & MIDDLE INITIAL",
          field: "Cosigner_First_Name_Middle_Initial",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNERS FIRST NAME & MIDDLE INITIAL", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER HOME PHONE",
          field: "Cosigner_Home_Phone",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER HOME PHONE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNR LAST NAME",
          field: "Cosigner_Last_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNR LAST NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER SEX",
          field: "Cosigner_Sex",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER SEX", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER SOCIAL SECURITY NUMBER",
          field: "Cosigner_SSAN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER SOCIAL SECURITY NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PROVINCE",
          field: "Province",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PROVINCE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COSIGNER WORK PHONE",
          field: "Cosigner_Work_Phone",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COSIGNER WORK PHONE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "POSTAL CODE",
          field: "Cosigner_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "POSTAL CODE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CITY TAX RATE",
          field: "City_Tax_Rate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CITY TAX RATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TOTAL CASH AMOUNT (LEASES)",
          field: "Total_Cash_Amount-Leases",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TOTAL CASH AMOUNT (LEASES)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CUSTOMER NUMBER",
          field: "Customer_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CUSTOMER NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEAL NUMBER (KEY FOR STORE/RECALL)",
          field: "Deal_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEAL NUMBER (KEY FOR STORE/RECALL)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEALER NAME",
          field: "Dealer_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEALER NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEALER ADDRESS",
          field: "Dealer_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEALER ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEALER COUNTY",
          field: "Dealer_County",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEALER COUNTY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEALER CITY",
          field: "Dealer_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEALER CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEALER NUMBER FOR TITLING",
          field: "Dealer_Number_for_Titling",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEALER NUMBER FOR TITLING", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEALER PHONE NUMBER",
          field: "Dealer_Phone_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEALER PHONE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEALER PROVINCE (USE FOR CANADA)",
          field: "Dealer_Province",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEALER PROVINCE (USE FOR CANADA)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "AUTHORIZED AGENT FOR DEALER",
          field: "Authorized_Agent_for_Dealer",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "AUTHORIZED AGENT FOR DEALER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEALER STATE",
          field: "Dealer_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEALER STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DEALER ZIP",
          field: "Dealer_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DEALER ZIP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DELIVERY DATE",
          field: "Delivery_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DELIVERY DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DELIVERY PRICE",
          field: "Delivery_Price",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DELIVERY PRICE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DIESEL YES NO",
          field: "Diesel_Yes_or_No",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DIESEL YES NO", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DRIVERS LICENSE EXPIRATION DATE",
          field: "Drivers_License_Expiration_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DRIVERS LICENSE EXPIRATION DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER'S DRIVERS LICENSE STATE",
          field: "Buyers_Drivers_License_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER'S DRIVERS LICENSE STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DOCUMENTATION FEE",
          field: "Documentation_Fee",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DOCUMENTATION FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "EMPLOYER ADDRESS",
          field: "Employer_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "EMPLOYER ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "EMPLOYER CITY",
          field: "Employer_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "EMPLOYER CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "EMPLOYER STATE",
          field: "Employer_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "EMPLOYER STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "EMPLOYER ZIP CODE",
          field: "Employer_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "EMPLOYER ZIP CODE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "NAME OF BUYER'S EMPLOYER",
          field: "Name_of_Buyers_Employer",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "NAME OF BUYER'S EMPLOYER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ENCUMBERED TITLE FEE",
          field: "Encumbered_Title_Fee",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ENCUMBERED TITLE FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ENGINE NUMBER OF CAR SOLD",
          field: "Engine_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ENGINE NUMBER OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ENGINE SIZE OF CAR SOLD",
          field: "Engine_Size_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ENGINE SIZE OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "EXCISE FEE FOR TITLE APP",
          field: "Excise_Fee_for_Title_App",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "EXCISE FEE FOR TITLE APP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "EXCISE TAX AMOUNT",
          field: "Excise_Tax_Amount",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "EXCISE TAX AMOUNT", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "FOUR BY FOUR YES NO",
          field: "Four_by_Four_Yes_or_No",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "FOUR BY FOUR YES NO", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "FOUR WHEEL DRIVE Y/N",
          field: "Four_Wheel_Drive_YN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "FOUR WHEEL DRIVE Y/N", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "FREIGHT CHARGE ON CAR SOLD",
          field: "Freight_Charge_on_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "FREIGHT CHARGE ON CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "FRONT WHEEL DRIVE Y/N",
          field: "Front_Wheel_Drive_YN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "FRONT WHEEL DRIVE Y/N", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "GROSS CAP COST OF VEHICLE",
          field: "Cross_Cap_Cost_of_Vehicle",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "GROSS CAP COST OF VEHICLE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "HORSE POWER OF CAR SOLD",
          field: "Horse_Power_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "HORSE POWER OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "STATE INSPECTION CERTIFICATE NUMBER",
          field: "State_Inspection_Certificate_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "STATE INSPECTION CERTIFICATE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DATE OF STATE INSPECTION",
          field: "Date_of_State_Inspection",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DATE OF STATE INSPECTION", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "INSPECTION FEE",
          field: "Inspection_Fee",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "INSPECTION FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "INTERIOR COLOR OF CAR SOLD",
          field: "Interior_Color_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "INTERIOR COLOR OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "STATE VEHICLE WAS LAST REGISTERED",
          field: "State_Vehicle_was_Last_Registered",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "STATE VEHICLE WAS LAST REGISTERED", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LICENSE EXPIRATION DATE",
          field: "License_Expiratoin_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LICENSE EXPIRATION DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LICENSE FEE",
          field: "License_Fee",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LICENSE FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LICENSE PLATE NUMBER OF CAR SOLD",
          field: "License_Plate_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LICENSE PLATE NUMBER OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DESCRIPTION OF LIEN",
          field: "Description_of_Lien",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DESCRIPTION OF LIEN", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LIENHOLDER CUSTOMER NUMBER",
          field: "Lienholder_Customer_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LIENHOLDER CUSTOMER NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TYPE OF LIEN",
          field: "Type_of_Lien",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TYPE OF LIEN", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "STICKER PRICE OF VEHICLE",
          field: "Sticker_Price_of_Vehcile",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "STICKER PRICE OF VEHICLE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LOCAL TAX RATE",
          field: "Local_Tax_Rate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LOCAL TAX RATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LOCAL TAX AMOUNT",
          field: "Local_Tax_Amount",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LOCAL TAX AMOUNT", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LUXURY TAX AMOUNT",
          field: "Luxury_Tax_Amount",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LUXURY TAX AMOUNT", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LUXURY TAX RATE",
          field: "Luxury_Tax_Rate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LUXURY TAX RATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LUXURY TAX THRESHOLD",
          field: "Luxury_Tax_Threshold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LUXURY TAX THRESHOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LUXURY TAX FLAG",
          field: "Luxury_Tax_Flag",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LUXURY TAX FLAG", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LUXURY TAX BASIS",
          field: "Luxury_Tax_Basis",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LUXURY TAX BASIS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "AMOUNT OF LUXURY TAX UPFRONT",
          field: "Amout_of_Luxury_Tax",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "AMOUNT OF LUXURY TAX UPFRONT", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MAKE OF CAR SOLD",
          field: "Make_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MAKE OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "VENDOR SPECIFIC MAKE CODE",
          field: "Make_Code",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "VENDOR SPECIFIC MAKE CODE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MAKE NUMBER OF CAR SOLD",
          field: "Make_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MAKE NUMBER OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MODEL DESCRIPTION OF CAR SOLD",
          field: "Model_Description_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MODEL DESCRIPTION OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MODEL NUMBER OF CAR SOLD",
          field: "Model_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MODEL NUMBER OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MANUFACTURERS REBATE",
          field: "Manufacturers_Rebate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MANUFACTURERS REBATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "YEAR VEHICLE WAS MANUFACTURED",
          field: "Year_Vehicle_of_Manufactured",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "YEAR VEHICLE WAS MANUFACTURED", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MOTIVE POWER (GAS DSL OTHER) OF CAR SOLD",
          field: "Motive_Power-Gas_DSL_Other-of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MOTIVE POWER (GAS DSL OTHER) OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MANUFACTURER CERT OF ORIGIN DATE",
          field: "Manufacturer_Cert_of_Orign_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MANUFACTURER CERT OF ORIGIN DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "NUMBER OF AXLES OF CAR SOLD",
          field: "Number_of_Axles_on_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "NUMBER OF AXLES OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "NUMBER OF DOORS ON CAR SOLD",
          field: "Number_of_Doors_on_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "NUMBER OF DOORS ON CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "NUMBER OF CYLINDERS OF CAR SOLD",
          field: "Number_of_Cylinders_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "NUMBER OF CYLINDERS OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "NUMBER OF PASSENGERS",
          field: "Number_of_Passengers",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "NUMBER OF PASSENGERS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "NEW / USED / OTHER - CAR SOLD",
          field: "New_Used_Other-Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "NEW / USED / OTHER - CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BUYER OCCUPATION",
          field: "Buyer_Occupation",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BUYER OCCUPATION", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ODOMETER READING OF CAR SOLD",
          field: "Odometer_Reading_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ODOMETER READING OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "OPERATOR ADDRESS",
          field: "Operator_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "OPERATOR ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "OPERATOR CITY",
          field: "Operator_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "OPERATOR CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "OPERATOR PHONE NUMBER",
          field: "Operator_Phone_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "OPERATOR PHONE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "OPERATOR STATE",
          field: "Operator_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "OPERATOR STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "OPERATOR ZIP",
          field: "Operator_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "OPERATOR ZIP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "OPERATOR OF VEHICLE IF OTHER THAN BUYER",
          field: "Operator_of_Vehicle_if_other_than_buyer",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "OPERATOR OF VEHICLE IF OTHER THAN BUYER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "OUT OF STATE SALE Y/N",
          field: "Out_of_State_Sale_YN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "OUT OF STATE SALE Y/N", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PCON PARM #10 (PRICE – Virginia)",
          field: "PCON_Parm_10_PRICE-Virginia",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PCON PARM #10 (PRICE – Virginia)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI INSURANCE COMPANY ADDRESS",
          field: "PDI_Insurance_Company_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI INSURANCE COMPANY ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI AGENT ADDRESS",
          field: "PDI_Agent_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI AGENT ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI AGENT NAME",
          field: "PDI_Agent_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI AGENT NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI COMPANY PHONE NUMBER",
          field: "PDI_Company_Phone_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI COMPANY PHONE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI COMPANY CODE NUMBER",
          field: "PDI_Company_Code_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI COMPANY CODE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI COMPANY CITY",
          field: "PDI_Company_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI COMPANY CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI EFFECTIVE DATE",
          field: "PDI_Effective_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI EFFECTIVE DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI EXPIRATION DATE",
          field: "PDI_Expiration_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI EXPIRATION DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI INSURANCE COMPANY NAME",
          field: "PDI_Insurance_Company_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI INSURANCE COMPANY NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI MONTHS",
          field: "PDI_Months",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI MONTHS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI PREMIUM",
          field: "PDI_Premium",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI PREMIUM", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PHYSICAL DAMAGE RESERVE",
          field: "Physical_Damage_Reserve",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PHYSICAL DAMAGE RESERVE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI RESERVE RATE",
          field: "PDI_Reserve_Rate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI RESERVE RATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI COMPANY STATE",
          field: "PDI_Company_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI COMPANY STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI COMPANY ZIP",
          field: "PDI_Company_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI COMPANY ZIP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CAR FOR PERSONAL BUSINESS AGRICULTURE",
          field: "Car_for_Personal_Business_Agriculture",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CAR FOR PERSONAL BUSINESS AGRICULTURE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PLATE NUM. OF CAR SOLD (IF <> LIC.NO)",
          field: "Plate_Num_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PLATE NUM. OF CAR SOLD (IF <> LIC.NO)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PDI POLICY NUMBER",
          field: "PDI_Policy_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PDI POLICY NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PREVIOUS OWNER ADDRESS",
          field: "Previous_Owner_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PREVIOUS OWNER ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PREVIOUS OWNER CITY",
          field: "Previous_Owner_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PREVIOUS OWNER CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PREVIOUS OWNER NAME",
          field: "Previous_Owner_Name",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PREVIOUS OWNER NAME", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PREVIOUS OWNER STATE",
          field: "Previous_Owner_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PREVIOUS OWNER STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PREVIOUS OWNER ZIP",
          field: "Previous_Owner_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PREVIOUS OWNER ZIP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PRICE/CAP COST OF VEHICLE",
          field: "Price_or_Cap_Cost_of_Vehicle",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PRICE/CAP COST OF VEHICLE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PROPERTY TAX FACTOR",
          field: "Property_Tax_Factor",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PROPERTY TAX FACTOR", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "PROPERTY TAX",
          field: "Property_Tax",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "PROPERTY TAX", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED OWNER ADDRESS",
          field: "Registered_Owner_Address",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED OWNER ADDRESS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED BUYER B/C/T (NY)",
          field: "Registered_Buyer_BCT-NY",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED BUYER B/C/T (NY)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED OWNER COUNTY",
          field: "Registered_Owner_County",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED OWNER COUNTY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED OWNER CITY",
          field: "Registered_Owner_City",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED OWNER CITY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED OWNER DATE OF BIRTH",
          field: "Registered_Owner_Date_of_Birth",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED OWNER DATE OF BIRTH", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTRATION EFFECTIVE DATE",
          field: "Registration_Effective_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTRATION EFFECTIVE DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTRATION EXPIRATION DATE",
          field: "Registration_Expiration_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTRATION EXPIRATION DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTRATION EXPIRATION YEAR",
          field: "Registration_Expiration_Year",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTRATION EXPIRATION YEAR", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTRATION FEE",
          field: "Registration_Fee",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTRATION FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED OWNER SEX",
          field: "Registered_Owner_Sex",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED OWNER SEX", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED OWNER STATE",
          field: "Registered_Owner_State",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED OWNER STATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED STATE OF CAR SOLD",
          field: "Registered_State_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED STATE OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTRATION TYPE OF CAR SOLD",
          field: "Registration_Type_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTRATION TYPE OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "YEAR VEHICLE WAS FIRST REGISTERED",
          field: "Year_Vehicle_was_First_Registered",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "YEAR VEHICLE WAS FIRST REGISTERED", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED OWNER ZIP",
          field: "Registered_Owner_ZIP",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED OWNER ZIP", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED OWNER OTHER THAN BUYER",
          field: "Registered_Owner_Other_than_Buyer",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED OWNER OTHER THAN BUYER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "RTD TAX AMOUNT (COLORADO)",
          field: "RTD_Tax_Amount-Colorado",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "RTD TAX AMOUNT (COLORADO)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "RTD TAX RATE",
          field: "RTD_Tax_Rate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "RTD TAX RATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "SALES TAX AMOUNT",
          field: "Sales_Tax_Amount",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "SALES TAX AMOUNT", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "SALES TAX RATE",
          field: "Sales_Tax_Rate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "SALES TAX RATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "STATE TAX RATE",
          field: "State_Tax_Rate",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "STATE TAX RATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LICENSE STICKER NUMBER OF CAR SOLD",
          field: "License_Sticker_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LICENSE STICKER NUMBER OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "STOCK NUMBER - CAR SOLD",
          field: "Stock_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "STOCK NUMBER - CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TAG NUMBER OF CAR SOLD",
          field: "Tag_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TAG NUMBER OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TAX BASE AMOUNT",
          field: "Tax_Base_Amount",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TAX BASE AMOUNT", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TAX CALC FOR TEXAS",
          field: "Calc_for_Texas",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TAX CALC FOR TEXAS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TAXABLE PRICE (KY)",
          field: "Taxable_Price-KY",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TAXABLE PRICE (KY)", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TAXABLE Y/N",
          field: "Taxable_YN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TAXABLE Y/N", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TEMPORARY CERTIFICATE NUMBER",
          field: "Temporary_Certificate_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TEMPORARY CERTIFICATE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TEMPORARY PLATE NUMBER OF CAR SOLD",
          field: "Temporary_Plate_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TEMPORARY PLATE NUMBER OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TEMP PLATE EXPIRATION DATE",
          field: "Temp_Plate_Expiration_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TEMP PLATE EXPIRATION DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TITLE FEE",
          field: "Title_Fee",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TITLE FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DATE OF TITLE",
          field: "Date_of_Title",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DATE OF TITLE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TITLE NUMBER OF CAR SOLD",
          field: "Title_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TITLE NUMBER OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "STATE CAR WILL BE TITLED IN",
          field: "State_Car_will_be_Titled_in",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "STATE CAR WILL BE TITLED IN", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TITLE TYPE",
          field: "Title_Type",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TITLE TYPE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TEMPORARY TAG FEE",
          field: "Temporary_Tag_Fee",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TEMPORARY TAG FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TOP COLOR OF CAR SOLD",
          field: "Top_Color_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TOP COLOR OF CAR SOLD", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TOTAL OF ALL TRADE-INS",
          field: "Total_of_All_Trade-ins",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TOTAL OF ALL TRADE-INS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE LICENSE STICKER NUMBER",
          field: "Trade_License_Sticker_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE LICENSE STICKER NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE NUMBERS THAT HAVE TAX CREDIT (EX: 13",
          field: "Trade_Numbers_That_Have_Tax_Credit",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE NUMBERS THAT HAVE TAX CREDIT (EX: 13", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK NAME OF TRADE IN #1",
          field: "Bank_Name_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK NAME OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK ADDRESS OF TRADE IN #1",
          field: "Bank_Address_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK ADDRESS OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE #1 BANK PHONE NUMBER",
          field: "Bank_Phone_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE #1 BANK PHONE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK CITY OF TRADE IN #1",
          field: "Bank_City_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK CITY OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK STATE FOR TRADE IN #1",
          field: "Bank_State_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK STATE FOR TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK ZIP OF TRADE IN #1",
          field: "Bank_ZIP_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK ZIP OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CARLINE OF TRADE IN #1",
          field: "Carline_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CARLINE OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COLOR OF TRADE IN #1",
          field: "Color_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COLOR OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COLOR CODE OF TRADE IN #1",
          field: "Color_Code_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COLOR CODE OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "NUMBER OF CYLINDERS OF TRADE IN #1",
          field: "Number_of_Cylinders_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "NUMBER OF CYLINDERS OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE #1 DECAL NUMBER",
          field: "Decal_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE #1 DECAL NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ENGINE NUMBER OF TRADE IN #1",
          field: "Engine_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ENGINE NUMBER OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE IN #1 ENGINE SIZE",
          field: "Engine_Size_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE IN #1 ENGINE SIZE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "HORSEPOWER OF TRADE IN #1",
          field: "Horsepower_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "HORSEPOWER OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ID NUMBER OF TRADE IN #1",
          field: "ID_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ID NUMBER OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TR1 LICENSE EXPIRATION DATE",
          field: "License_Expiration_Date",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TR1 LICENSE EXPIRATION DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE 1 LICENSE FEE",
          field: "License_Fee_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE 1 LICENSE FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LICENSE NUMBER OF TRADE IN #1",
          field: "License_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LICENSE NUMBER OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MAKE OF TRADE IN #1",
          field: "Make_of_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MAKE OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MAKE NUMBER OF TRADE IN #1",
          field: "Make_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MAKE NUMBER OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MODEL DESCRIPTION OF TRADE IN #1",
          field: "Model_Description_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MODEL DESCRIPTION OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MODEL NUMBER OF TRADE IN #1",
          field: "Model_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MODEL NUMBER OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE IN #1 NUMBER OF DOORS",
          field: "Number_of_Doors_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE IN #1 NUMBER OF DOORS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE IN #1 NUMBER OF PASSENGERS",
          field: "Number_of_Passengers_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE IN #1 NUMBER OF PASSENGERS", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTRATION NUMBER OF TRADE IN #1",
          field: "Registration_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTRATION NUMBER OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "REGISTERED STATE OF TRADE IN #1",
          field: "Registered_State_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "REGISTERED STATE OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "YEAR OF TRADE IN #1 REGISTRATION",
          field: "Year_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "YEAR OF TRADE IN #1 REGISTRATION", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "STOCK NUMBER OF TRADE IN #1",
          field: "Stock_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "STOCK NUMBER OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE IN #1 TAB NUMBER",
          field: "Tab_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE IN #1 TAB NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TITLE NUMBER OF TRADE IN #1",
          field: "Tab_Number_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TITLE NUMBER OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE IN #1 TRANSMISSION POWER",
          field: "Transmission_Power_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE IN #1 TRANSMISSION POWER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE IN #1 TRIM COLOR",
          field: "Trim_Color_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE IN #1 TRIM COLOR", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "VEHICLE CLASS OF TRADE IN #1",
          field: "Vehicle_Class_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "VEHICLE CLASS OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "WEIGHT OF TRADE IN #1",
          field: "Weight_of_Trade_in_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "WEIGHT OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "YEAR OF TRADE IN #1",
          field: "Placeholder_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "YEAR OF TRADE IN #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK NAME OF TRADE IN #2",
          field: "Bank_Name_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK NAME OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK ADDRESS OF TRADE IN #2",
          field: "Bank_Address_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK ADDRESS OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE #2 BANK PHONE NUMBER",
          field: "Bank_Phone_Number_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE #2 BANK PHONE NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK CITY OF TRADE IN #2",
          field: "Bank_City_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK CITY OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK STATE OF TRADE IN #2",
          field: "Bank_State_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK STATE OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "BANK ZIP OF TRADE IN #2",
          field: "Bank_ZIP_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "BANK ZIP OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "CARLINE OF TRADE IN #2",
          field: "Carline_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "CARLINE OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COLOR OF TRADE IN #2",
          field: "Color_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COLOR OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "COLOR CODE OF TRADE IN #2",
          field: "Color_Code_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "COLOR CODE OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "NUMBER OF CYLINDERS OF TRADE IN #2",
          field: "Number_of_Cylinders_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "NUMBER OF CYLINDERS OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ENGINE NUMBER OF TRADE IN #2",
          field: "Engine_Number_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ENGINE NUMBER OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ID NUMBER OF TRADE IN #2",
          field: "ID_Number_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ID NUMBER OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE #2 KEY NUMBER #1",
          field: "Key_Number_1_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE #2 KEY NUMBER #1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE #2 KEY NUMBER #2",
          field: "Key_Number_2_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE #2 KEY NUMBER #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TR2 LICENSE EXPIRATION DATE",
          field: "License_Expiration_Date_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TR2 LICENSE EXPIRATION DATE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE 2 LICENSE FEE",
          field: "License_Fee_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE 2 LICENSE FEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "LICENCE NUMBER OF TRADE IN #2",
          field: "License_Number_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "LICENCE NUMBER OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MAKE OF TRADE IN #2",
          field: "Make_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MAKE OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        }, ///
        {
          label: "MAKE NUMBER OF TRADE IN #2",
          field: "Model_Description_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MAKE NUMBER OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MODEL DESCRIPTION OF TRADE IN #2",
          field: "Model_Number_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MODEL DESCRIPTION OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "MODEL NUMBER OF TRADE IN #2",
          field: "Stock_Number_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MODEL NUMBER OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "STOCK NUMBER OF TRADE IN #2",
          field: "Tab_Number_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "STOCK NUMBER OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TRADE IN #2 TAB NUMBER",
          field: "Title_Number_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TRADE IN #2 TAB NUMBER", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "TITLE NUMBER OF TRADE IN #2",
          field: "Trim_Color_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "TITLE NUMBER OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "VEHICLE CLASS OF TRADE IN #2",
          field: "Vehicle_Class_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "VEHICLE CLASS OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "WEIGHT OF TRADE IN #2",
          field: "Weight_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "WEIGHT OF TRADE IN #2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Year_of_Trade_in_2",
          field: "Year_of_Trade_in_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Year_of_Trade_in_2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Bank_Name_of_Trade_in_3",
          field: "Bank_Name_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Bank_Name_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Bank_Address_of_Trade_in_3",
          field: "Bank_Address_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Bank_Address_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Bank_Phone_Number_of_Trade_in_3",
          field: "Bank_Phone_Number_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Bank_Phone_Number_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Bank_City_of_Trade_in_3",
          field: "Bank_City_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Bank_City_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Bank_State_of_Trade_in_3",
          field: "Bank_State_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Bank_State_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Bank_ZIP_of_Trade_in_3",
          field: "Bank_ZIP_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Bank_ZIP_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Carline_of_Trade_in_3",
          field: "Carline_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Carline_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Color_of_Trade_in_3",
          field: "Color_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Color_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Color_Code_of_Trade_in_3",
          field: "Color_Code_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Color_Code_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Number_of_Cylinders_of_Trade_in_3",
          field: "Number_of_Cylinders_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Number_of_Cylinders_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Engine_Number_of_Trade_in_3",
          field: "Engine_Number_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Engine_Number_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "ID_Number_of_Trade_in_3",
          field: "ID_Number_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "ID_Number_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Key_Number_1_of_Trade_in_3",
          field: "Key_Number_1_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Key_Number_1_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Key_Number_2_of_Trade_in_3",
          field: "Key_Number_2_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Key_Number_2_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "License_Expiration_Date_of_Trade_in_3",
          field: "License_Expiration_Date_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "License_Expiration_Date_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "License_Fee_of_Trade_in_3",
          field: "License_Fee_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "License_Fee_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "License_Number_of_Trade_in_3",
          field: "License_Number_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "License_Number_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Make_of_Trade_in_3",
          field: "Make_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Make_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Make_Number_of_Trade_in_3",
          field: "Make_Number_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Make_Number_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Model_Description_of_Trade_in_3",
          field: "Model_Description_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Model_Description_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Model_Number_of_Trade_in_3",
          field: "Model_Number_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Model_Number_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Stock_Number_of_Trade_in_3",
          field: "Stock_Number_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Stock_Number_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Tab_Number_of_Trade_in_3",
          field: "Tab_Number_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Tab_Number_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Title_Number_of_Trade_in_3",
          field: "Title_Number_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Title_Number_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Trim_Color_of_Trade_in_3",
          field: "Trim_Color_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Trim_Color_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Vehicle_Class_of_Trade_in_3",
          field: "Vehicle_Class_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Vehicle_Class_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Weight_of_Trade_in_3",
          field: "Weight_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Weight_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Year_of_Trade_in_3",
          field: "Year_of_Trade_in_3",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Year_of_Trade_in_3", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Transmission_Type-5SPD_AUTO",
          field: "Transmission_Type-5SPD_AUTO",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Transmission_Type-5SPD_AUTO", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Transfer_Registration_Fee",
          field: "Transfer_Registration_Fee",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Transfer_Registration_Fee", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Transferred_Cars_Plate_ID",
          field: "Transferred_Cars_Plate_ID",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Transferred_Cars_Plate_ID", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Transferred_Plate_Number",
          field: "Transferred_Plate_Number",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Transferred_Plate_Number", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Transferred_Title_Number_of_Car_Sold",
          field: "Transferred_Title_Number_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Transferred_Title_Number_of_Car_Sold", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Title_Transfer_YN",
          field: "Title_Transfer_YN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Title_Transfer_YN", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Trip_Color_of_Car_Sold",
          field: "Trip_Color_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Trip_Color_of_Car_Sold", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Turbo_Charge_Yes_No",
          field: "Turbo_Charge_Yes_No",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Turbo_Charge_Yes_No", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Turbo_Charged_YN",
          field: "Turbo_Charged_YN",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Turbo_Charged_YN", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Type_of_Deal-Deal_or_Lease",
          field: "Type_of_Deal-Deal_or_Lease",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Type_of_Deal-Deal_or_Lease", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Vehicle_Classification-Car_or_Truck",
          field: "Vehicle_Classification-Car_or_Truck",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Vehicle_Classification-Car_or_Truck", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Vehicle_Gross",
          field: "Vehicle_Gross",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Vehicle_Gross", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Weight_Fee_on_Commercial_Vehicle",
          field: "Weight_Fee_on_Commercial_Vehicle",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Weight_Fee_on_Commercial_Vehicle", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Witness_1",
          field: "Witness_1",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Witness_1", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Witness_2",
          field: "Witness_2",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Witness_2", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Weight_of_Car_Sold",
          field: "Weight_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Weight_of_Car_Sold", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Year_of_Car_Sold",
          field: "Year_of_Car_Sold",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Year_of_Car_Sold", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Sales_Person",
          field: "Sales_Person",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Sales_Person", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "Sales_Person_ID",
          field: "Sales_Person_ID",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Sales_Person_ID", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          label: "DMVFEE",
          field: "DMVFEE",
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "DMVFEE", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        }
        /*{
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                    }*/
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        page: 1,
        perPage: 25,
        sort: {
          field: "id",
          type: "asc"
        },
        perPageDropdown: []
      },
      customer_id: "",
      customer_name: "",
      recordsCounts: "",
      selectedRows: 0,
      permissionsArray: ["can_manage_users"],

      displayPageTask: 7,
      jumpToPageTask: 0,
      pageCompareTask: 0,
      paginationDisplayRowsTask: "",
      inventoryId: { id: "0", name: "Select Inventory" },
      inventoryOptions: [],
      dealNoError: "",
      deal_no: "",
      errorsArraySize:0,
      errorString: "",
    };
  },
  beforeMount: function() {
    self = this;
    EventBus.$emit("menu-selection-changed", "dashboard");
  },
  mounted: function() {
    self.customer_id = self.$route.params.custId;
    //self.getUserRole();
    //self.getUserPermissions();

    this.jumpToPageTask = this.serverParams.page;
    this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
    $("#jumpToPageTask").on("keyup", function(e) {
      if (e.keyCode === 13) {
        //checks whether the pressed key is "Enter"
        self.jumpToInputPageTask(self.jumpToPageTask);
      }
    });

    this.serverParams.perPageDropdown.push(25);
    this.serverParams.perPageDropdown.push(50);
    this.serverParams.perPageDropdown.push(100);
    this.serverParams.perPageDropdown.push(200);
    this.serverParams.perPageDropdown.push(500);

    self.loadInventoryParts();
  },

  methods: {
    loadInventoryParts: function() {
      console.log(self.deal_no);
      self.firstLoad = 1;
      var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage);
      if (newPage) {
        if (newPage < self.serverParams.page) {
          self.serverParams.page = newPage;
        }
      }
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("api_token")
        },
        params: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: self.serverParams.columnFilters,
          messageData: self.message,
          sort: self.serverParams.sort,
          deal_no: self.deal_no
        }
      };
      self.disableShow = true;
      self.disableExport = true;
      HTTP.get("list-by-deal-no", config)
        .then(function(response) {
          self.disableShow = false;
          self.disableExport = false;
          //console.log('inventory',response);
          if (response.status == "200") {
            self.rows = response.data.results;
            self.totalRecords = response.data.totalRecords;
            //self.inventoryHeader = response.data.inventory_name;
            //self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
          }
          self.paginationDisplayRowsTask = self.getRecords(
            self.serverParams.page,
            self.serverParams.perPage,
            self.totalRecords
          );
        })
        .catch(function(err) {
          self.disableShow = false;
          self.disableExport = false;
          console.log("err", err);
          if (err.response.status == 0) {
            self.error = "Remote server can not be reachable";
          } else {
            //redirect to login page if user not authenticated
            if (err.response.status == 401) {
              //clear previous data
              localStorage.clear();
              self.$router.push("/");
            }
            self.error = err.response.data.message;
          }
        });
    },
    exportData: function() {
      //self.disableButtons.saveButton = true;
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("api_token")
        }
      };
      var formData = {
        rowData: self.rows,
        //columns: self.columns
      };
      self.errorsArraySize = 0;
      self.errorString = "";
      HTTP.post("list-by-deal-no-export", formData, config)
        .then(function(response) {
            console.log(response);
          if (response.data.web != undefined) {
              self.errorsArraySize = response.data.errorsArraySize;
              self.errorString = response.data.errorString;
              // Below is not working when a referrer bucket policy is added in S3
              // window.open(response.data.web, "_blank");
              location.href = response.data.web;
          }
        })
        .catch(function(error) {
          /*self.error_msg_login = "";
                        self.buttonNames.saveButton = "Save";
                        self.disableButtons.saveButton = false;
                        self.catchHandler(error);*/
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue